var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("供应点管理")]),
              _c("el-breadcrumb-item", [_vm._v("退货退款记录")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.listParams, "label-width": "100px" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "领货日期：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: "请选择领货日期",
                                size: "small",
                              },
                              model: {
                                value: _vm.listParams.date,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listParams, "date", $$v)
                                },
                                expression: "listParams.date",
                              },
                            },
                            _vm._l(_vm.dateList, function (item) {
                              return _c("el-option", {
                                key: item.dateId,
                                attrs: {
                                  value: item.dateId,
                                  label: _vm._f("formatDate")(item.date),
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.loadTableData },
                            },
                            [_vm._v(" 查询 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.tableLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", width: "60", label: "序号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              (_vm.pager.pageIndex > 1
                                ? (_vm.pager.pageIndex - 1) * _vm.pager.pageSize
                                : 0) +
                                scope.$index +
                                1
                            ),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "orderNo", align: "center", label: "订单编号" },
              }),
              _c("el-table-column", {
                attrs: { prop: "mobile", align: "center", label: "手机号" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsTitle",
                  align: "center",
                  label: "菜品名称",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "specTitle", align: "center", label: "规格" },
              }),
              _c("el-table-column", {
                attrs: { prop: "quantity", align: "center", label: "数量" },
              }),
              _c("el-table-column", {
                attrs: { prop: "price", align: "center", label: "价格" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "returnCause",
                  align: "center",
                  label: "退货原因",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.returnCause
                          ? _c("span", [
                              scope.row.returnCause.length > 10
                                ? _c(
                                    "span",
                                    [
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            placement: "top-start",
                                            width: "200",
                                            trigger: "hover",
                                            content: scope.row.returnCause,
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticStyle: { color: "#606266" },
                                              attrs: {
                                                slot: "reference",
                                                type: "text",
                                              },
                                              slot: "reference",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("formatLimitLength")(
                                                      scope.row.returnCause
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _c("span", [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.returnCause)),
                                    ]),
                                  ]),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.revocation === 1
                          ? _c(
                              "confirm-button",
                              {
                                staticStyle: { margin: "0 10px" },
                                attrs: {
                                  type: "text",
                                  title: "确认要撤销该条数据？",
                                },
                                on: {
                                  confirmed: function ($event) {
                                    return _vm.repealItem(scope.row.id)
                                  },
                                },
                              },
                              [_c("span", [_vm._v("撤销")])]
                            )
                          : _vm._e(),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              content: "该数据不可撤销",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              { attrs: { type: "text", disabled: "" } },
                              [_vm._v("撤销")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }